import {DateTime} from "luxon";
import {BASE_MONTHS} from "../../../../helpers/months";
import type {EBirdMyDataSchema} from "ebird-mydata-reader";
import type {SpeciesSightingWeek} from "./types";

export function getSpeciesSightingWeeks(observations: EBirdMyDataSchema[]): SpeciesSightingWeek[] {
    const counts = new Map<string, number>();

    for (const observation of observations) {
        const date = DateTime.fromISO(observation.date);
        if (!date.isValid) continue;

        const week = Math.ceil(date.day / 7);
        const key = `${date.month}-${week}`;
        counts.set(key, (counts.get(key) ?? 0) + 1);
    }

    return BASE_MONTHS.flatMap(({value: month}) => Array.from({length: 5}, (_, index) => ({
        month,
        week: index + 1,
        observationCount: counts.get(`${month}-${index + 1}`) ?? 0
    })));
}

export function getSightingIntensity(count: number, maxCount: number) {
    return .3 + (.7 * (Math.log(count + 1) / Math.log(maxCount + 1)));
}
